import * as React from 'react';
import { Container } from '@nextui-org/react';

interface AppFullWidthContainerProps {
  children: React.ReactNode;
}

/**
 * @name AppFullWidthContainer
 * @description tbd...
 */
export function AppFullWidthContainer(props: AppFullWidthContainerProps) {
  const { children } = props;

  return (
    <Container fluid css={{ p: 0 }}>
      {children}
    </Container>
  );
}
